import React from 'react';
import ProductPageTemplate from './ProductPageTemplate';
import {
  Teams,
  UserManagement,
  ManageConfiguration,
} from '../../assets';

const AdminPage = () => {
  const productData = {
    productName: 'Admin Panel',
    pageUrlOverride: 'https://shipmnts.com/products/admin',
    tagline: 'Centralized Control for Your Logistics Operations',
    metaDescription: 'Centralised admin panel for freight ERP: manage users, roles, permissions, and system configuration across your entire logistics operation.',
    description: 'Manage users, roles, permissions, subscriptions, and system-wide configurations from a single, powerful interface.',
    icon: Teams,
    features: [
      {
        title: 'User Management with Custom Permission Roles',
        description: 'Manage users, send invitations, and assign granular roles and permissions to ensure secure access control.',
        image: UserManagement,
      },
      {
        title: 'Manage Your Configuration and Data',
        description: 'Centralized control over system configurations, custom fields, and organizational data parameters.',
        image: ManageConfiguration,
      },
    ],
  };

  return <ProductPageTemplate {...productData} />;
};

export default AdminPage;
